import React from 'react'
import { BillingSettingsPageBusinessLogicProvider } from './context'

interface ComponentProps extends React.ComponentProps<any> { }

export const BillingSettingsPageLogic: React.FunctionComponent<ComponentProps> = (props: ComponentProps) => {
    return <BillingSettingsPageBusinessLogicProvider>{props.children}</BillingSettingsPageBusinessLogicProvider>
}

